import { AuditLogScreen, createAuditLogClient } from '@pay-roadrunner/audit-log-ui';
import { authFetch } from '../auth/authFetch';
import { getApiBaseUrl } from '../auth/api';

const client = createAuditLogClient({ getBaseUrl: getApiBaseUrl, fetchImpl: authFetch });

export const AuditLogPage = () => <AuditLogScreen client={client} />;
